module.exports = global["App3D"] = require("-!/var/www/clients/client44/web149/web/node_modules/ts-loader/index.js??ref--0-0!./App3D.ts");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?App3D!./src/script/app3D/App3D.ts-exposed
// module id = 37
// module chunks = 1 2